import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  FiPrinter, FiDownload, FiShare2, FiMail, FiCopy,
  FiCheck, FiX, FiChevronDown,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import InvoiceOne from "../InvoiceUI/InvoiceOne";
import InvoiceTwo from "../InvoiceUI/InvoiceTwo";
import InvoiceThree from "../InvoiceUI/InvoiceThree";
import InvoiceFour from "../InvoiceUI/InvoiceFour";
import InvoiceFive from "../InvoiceUI/InvoiceFive";
import InvoiceSix from "../InvoiceUI/InvoiceSix";
import InvoiceSeven from "../InvoiceUI/InvoiceSeven";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../baseurl";
import html2pdf from "html2pdf.js";

const invoiceTemplates = [
  { id: 1, name: "Classic Blue",    component: InvoiceOne },
  { id: 2, name: "Modern Minimal",  component: InvoiceTwo },
  { id: 3, name: "Professional",    component: InvoiceThree },
  { id: 4, name: "Elegance",        component: InvoiceFour },
  { id: 5, name: "Mosaic",          component: InvoiceFive },
  { id: 6, name: "Blueprint",       component: InvoiceSix },
  { id: 7, name: "Noir",            component: InvoiceSeven },
];

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

:root {
  --pi-teal:      #0a5556;
  --pi-teal-mid:  #0c7172;
  --pi-teal-lite: #14b8a6;
  --pi-gold:      #FFD166;
  --pi-bg:        #eef6f6;
  --pi-white:     #ffffff;
  --pi-border:    rgba(10,85,86,0.10);
  --pi-text:      #0f2a2a;
  --pi-muted:     #5a8080;
  --pi-danger:    #ef4444;
  --pi-success:   #10b981;
  --pi-trans:     all 0.18s cubic-bezier(0.4,0,0.2,1);
}

@keyframes pi__spin    { to { transform: rotate(360deg); } }
@keyframes pi__fadeUp  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
@keyframes pi__pulse   { 0%,100%{opacity:1} 50%{opacity:0.6} }
@keyframes pi__copied  { 0%{transform:scale(0.8)} 60%{transform:scale(1.15)} 100%{transform:scale(1)} }

/* ── page wrapper ── */
.pi__page {
  font-family: 'DM Sans', sans-serif;
  min-height: 100vh;
  background: var(--pi-bg);
  position: relative;
}

/* ══════════════════════════════════════
   TOP CONTROL BAR
══════════════════════════════════════ */
.pi__bar {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  background: var(--pi-white);
  border-bottom: 1px solid var(--pi-border);
  box-shadow: 0 2px 16px rgba(10,85,86,0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  height: 62px;
  gap: 16px;
}

/* brand */
.pi__bar-brand {
  display: flex; align-items: center; gap: 10px;
}
.pi__bar-icon {
  width: 36px; height: 36px; border-radius: 11px;
  background: linear-gradient(135deg, var(--pi-teal), var(--pi-teal-lite));
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; color: #fff; flex-shrink: 0;
}
.pi__bar-title {
  font-family: 'Sora', sans-serif; font-size: 14px; font-weight: 800;
  color: var(--pi-text); letter-spacing: -0.02em;
}
.pi__bar-inv {
  font-size: 11.5px; color: var(--pi-muted); font-weight: 500;
}

/* button groups */
.pi__bar-actions {
  display: flex; align-items: center; gap: 8px;
}
.pi__divider {
  width: 1px; height: 28px; background: var(--pi-border); flex-shrink: 0; margin: 0 4px;
}

/* base action button */
.pi__btn {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 9px 16px; border-radius: 11px; border: none; cursor: pointer;
  font-size: 12.5px; font-family: 'Sora', sans-serif; font-weight: 700;
  transition: var(--pi-trans); white-space: nowrap;
}

/* print */
.pi__btn--print {
  background: linear-gradient(135deg, var(--pi-teal), var(--pi-teal-lite));
  color: #fff; box-shadow: 0 3px 10px rgba(10,85,86,0.24);
}
.pi__btn--print:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(10,85,86,0.32); }

/* download */
.pi__btn--download {
  background: #0f2a2a; color: #fff;
  box-shadow: 0 3px 10px rgba(15,42,42,0.22);
}
.pi__btn--download:hover { background: #1a3a3a; transform: translateY(-1px); }
.pi__btn--download:disabled { opacity: .55; cursor: not-allowed; transform: none; }

/* share icon buttons */
.pi__share-btn {
  width: 38px; height: 38px; border-radius: 10px; border: none; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 16px; transition: var(--pi-trans);
}
.pi__share-btn--wa    { background: rgba(37,211,102,0.12); color: #128c3e; border: 1.5px solid rgba(37,211,102,0.25); }
.pi__share-btn--email { background: rgba(234,67,53,0.10);  color: #c62828; border: 1.5px solid rgba(234,67,53,0.25); }
.pi__share-btn--copy  { background: rgba(10,85,86,0.08);   color: var(--pi-teal); border: 1.5px solid var(--pi-border); }
.pi__share-btn--wa:hover    { background: #25d366; color: #fff; border-color: #25d366; transform: translateY(-1px); }
.pi__share-btn--email:hover { background: #ea4335; color: #fff; border-color: #ea4335; transform: translateY(-1px); }
.pi__share-btn--copy:hover  { background: var(--pi-teal); color: #fff; border-color: var(--pi-teal); transform: translateY(-1px); }

/* label for share group */
.pi__share-lbl {
  font-size: 10.5px; font-family: 'Sora', sans-serif; font-weight: 700;
  letter-spacing: 0.07em; text-transform: uppercase; color: var(--pi-muted);
  padding: 0 2px;
}

/* generating spinner */
.pi__spin { animation: pi__spin 0.8s linear infinite; }

/* copy success flash */
.pi__copied-anim { animation: pi__copied 0.35s ease both; }

/* ══════════════════════════════════════
   INVOICE AREA
══════════════════════════════════════ */
.pi__content {
  padding-top: 80px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: #dde8e8;
}

.pi__invoice-wrap {
  background: white;
  width: 210mm;
  min-height: 297mm;
  margin: 30px 0 60px;
  box-shadow: 0 8px 40px rgba(10,85,86,0.16), 0 2px 8px rgba(10,85,86,0.08);
  overflow: hidden;
  flex-shrink: 0;
}

/* loading state */
.pi__loading {
  height: 70vh;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center; gap: 16px;
  animation: pi__fadeUp 0.3s ease both;
}
.pi__loading-icon {
  width: 60px; height: 60px; border-radius: 18px;
  background: linear-gradient(135deg, var(--pi-teal), var(--pi-teal-lite));
  display: flex; align-items: center; justify-content: center; font-size: 26px; color: #fff;
  box-shadow: 0 6px 20px rgba(10,85,86,0.28);
  animation: pi__pulse 1.6s ease infinite;
}
.pi__loading-txt {
  font-family: 'Sora', sans-serif; font-size: 14px; font-weight: 700;
  color: var(--pi-text);
}
.pi__loading-sub { font-size: 12.5px; color: var(--pi-muted); }

/* ══════════════════════════════════════
   PRINT MEDIA
══════════════════════════════════════ */
@page { size: A4 portrait; margin: 0; }
@media print {
  .pi__bar, .pi__no-print { display: none !important; }
  .pi__page    { background: white !important; }
  .pi__content {
    padding-top: 0 !important; background: white !important;
    display: block !important; min-height: unset !important;
  }
  .pi__invoice-wrap {
    width: 210mm !important; min-height: 297mm !important;
    margin: 0 !important; box-shadow: none !important;
  }
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
}

@media (max-width: 600px) {
  .pi__bar { padding: 0 14px; gap: 8px; }
  .pi__btn span { display: none; }
  .pi__bar-inv { display: none; }
  .pi__share-lbl { display: none; }
}
`;

/* ═══════════════════════════════════════════════════
   COMPONENT — ALL BACKEND LOGIC COMPLETELY UNCHANGED
═══════════════════════════════════════════════════ */
const PrintInvoice = () => {
  const { id } = useParams();
  const invoiceId = atob(id);
  const [selectedTemplateId, setSelectedTemplateId] = useState(1);
  const [invoiceData, setInvoiceData]               = useState(null);
  const [isGenerating, setIsGenerating]             = useState(false);
  const [copied, setCopied]                         = useState(false);
  const token = localStorage.getItem("auth_token");
  const invoiceRef = useRef();
  const currentUrl = window.location.href;

  /* ── fetchInvoice (UNCHANGED) ── */
  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await axios.get(`${baseurl}getInvoiceById/${invoiceId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.success) setInvoiceData(res.data.data);
      } catch (err) {
        console.error("Failed to load invoice:", err);
      }
    };
    fetchInvoice();
  }, [invoiceId, token]);

  /* ── fetchTemplate (UNCHANGED) ── */
  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const res = await axios.get(`${baseurl}getBusinessInvoiceTemplate`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.success && res.data.template_id) {
          setSelectedTemplateId(Number(res.data.template_id));
        }
      } catch (err) {
        console.error("Template fetch failed");
      }
    };
    fetchTemplate();
  }, [token]);

  /* ── auto-print (UNCHANGED) ── */
  useEffect(() => {
    if (invoiceData) {
      const timer = setTimeout(() => {
        // window.print();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [invoiceData]);

  /* ── handlers ── */
  const handlePrint = () => window.print();

  const handleDownloadPDF = () => {
    const element = invoiceRef.current;
    if (!element) return;
    setIsGenerating(true);
    const opt = {
      margin: 0,
      filename: `Invoice_${invoiceData?.invoice_number || "Draft"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, windowWidth: 794 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save().then(() => setIsGenerating(false));
  };

  const shareWhatsApp = () => {
    const text = `Please find the invoice ${invoiceData?.invoice_number || ""} here: ${currentUrl}`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`, "_blank");
  };

  const shareEmail = () => {
    const subject = `Invoice ${invoiceData?.invoice_number || ""}`;
    const body = `Hello, you can view and download the invoice here: ${currentUrl}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const copyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
    Swal.fire({
      icon: "success", title: "Link Copied!",
      toast: true, position: "top-end",
      timer: 2000, showConfirmButton: false,
    });
  };

  /* ── renderSelectedTemplate (UNCHANGED) ── */
  const renderSelectedTemplate = () => {
    const selectedTemplate = invoiceTemplates.find(t => t.id === selectedTemplateId);
    if (!selectedTemplate || !invoiceData) return null;
    const TemplateComponent = selectedTemplate.component;
    return <TemplateComponent invoiceData={invoiceData} />;
  };

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <div className="pi__page">

        {/* ── TOP CONTROL BAR ── */}
        <div className="pi__bar pi__no-print">

          {/* Brand / Invoice info */}
          <div className="pi__bar-brand">
            <div className="pi__bar-icon">
              <FiPrinter size={17} />
            </div>
            <div>
              <div className="pi__bar-title">Invoice Preview</div>
              {invoiceData && (
                <div className="pi__bar-inv">{invoiceData.invoice_number}</div>
              )}
            </div>
          </div>

          {/* Action buttons */}
          <div className="pi__bar-actions">

            {/* Print */}
            <button className="pi__btn pi__btn--print" onClick={handlePrint}>
              <FiPrinter size={14} /> <span>Print</span>
            </button>

            {/* Download PDF */}
            <button
              className="pi__btn pi__btn--download"
              onClick={handleDownloadPDF}
              disabled={isGenerating || !invoiceData}
            >
              {isGenerating
                ? <><FiDownload size={14} className="pi__spin" /> <span>Generating…</span></>
                : <><FiDownload size={14} /> <span>Download PDF</span></>
              }
            </button>

            <div className="pi__divider" />

            {/* Share label */}
            <span className="pi__share-lbl">Share</span>

            {/* WhatsApp */}
            <button
              className="pi__share-btn pi__share-btn--wa"
              onClick={shareWhatsApp}
              title="Share on WhatsApp"
            >
              <FaWhatsapp size={17} />
            </button>

            {/* Email */}
            <button
              className="pi__share-btn pi__share-btn--email"
              onClick={shareEmail}
              title="Send via Email"
            >
              <FiMail size={15} />
            </button>

            {/* Copy Link */}
            <button
              className={`pi__share-btn pi__share-btn--copy ${copied ? "pi__copied-anim" : ""}`}
              onClick={copyLink}
              title="Copy Link"
            >
              {copied ? <FiCheck size={15} /> : <FiCopy size={15} />}
            </button>

          </div>
        </div>

        {/* ── INVOICE RENDER AREA ── */}
        <div className="pi__content">
          <div className="pi__invoice-wrap">
            <div ref={invoiceRef} id="printable-area">
              {invoiceData ? (
                renderSelectedTemplate()
              ) : (
                <div className="pi__loading pi__no-print">
                  <div className="pi__loading-icon">
                    <FiPrinter size={26} />
                  </div>
                  <div className="pi__loading-txt">Preparing Invoice…</div>
                  <div className="pi__loading-sub">Fetching your invoice details</div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default PrintInvoice;
